import { ref } from 'vue';
import Request from '@/services/request';
import { CATEGORY_COMMISSION_CAMPAIGNS_AVAILABLE } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useCategoryCommissionCampaignsAvailable() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const fetchData = async ({
    sortBy,
    page,
    size,
    categoryIds,
    campaignName,
  } = {}) => {
    isLoading.value = true;

    const trimmedName =
      typeof campaignName === 'string' ? campaignName.trim() : '';

    const params = {
      ...(sortBy && { sortBy }),
      ...(page !== undefined && { page }),
      ...(size && { size }),
      ...(categoryIds?.length && { categoryIds: categoryIds.join(',') }),
      ...(trimmedName && { name: trimmedName }),
    };

    try {
      const response = await Req.get(
        CATEGORY_COMMISSION_CAMPAIGNS_AVAILABLE,
        Object.keys(params).length ? params : null,
        {
          baseURL: '/sellerofficeapi/rest',
          headers: { Accept: 'application/json' },
        },
      );

      if (!response.status || response.status !== 200) {
        throw new Error('Network response was not OK');
      }

      data.value = response.data;
      error.value = null;
    } catch (err) {
      error.value = err || null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    data,
    error,
    isLoading,
    fetchData,
  };
}
